export const COLORS = {
  primary: {
    lighter: '#FBE8E7',
    light: '#FFA590',
    main: '#FF6444',
    dark: '#B54730',
    darker: '#6B2A1D',
    lightContrastText: '#FCFDFD',
    darkContrastText: '#1b1b1b',
  },
  secondary: {
    lighter: '#E5E7F2',
    light: '#BEC2DF',
    main: '#041162',
    dark: '#020C45',
    darker: '#010623',
    contrastText: '#FFFFFF',
  },
  info: {
    lighter: '#DBF1FE',
    light: '#94CBFD',
    main: '#4D98F9',
    dark: '#2657B3',
    darker: '#0E2977',
    contrastText: '#FFFFFF',
  },
  success: {
    lighter: '#F3FDCF',
    light: '#CDF670',
    main: '#94E216',
    dark: '#5CA20B',
    darker: '#346C04',
    contrastText: '#ffffff',
  },
  warning: {
    lighter: '#FEF6D7',
    light: '#FEDE86',
    main: '#FCBA37',
    dark: '#B5771B',
    darker: '#78440A',
    contrastText: '#1C252E',
  },
  error: {
    lighter: '#FFE8EB',
    light: '#FF7487',
    main: '#FF1837',
    dark: '#B92237',
    darker: '#732C36',
    contrastText: '#FFFFFF',
  },
  grey: {
    '50': '#FCFDFD',
    '100': '#F9F9FB',
    '200': '#EDEEF2',
    '300': '#DBDDE5',
    '400': '#B8BBCC',
    '500': '#9A9FB6',
    '600': '#7D82A1',
    '700': '#565B76',
    '800': '#383B4D',
    '900': '#22242F',
  },
  common: {
    black: '#120A08',
    white: '#FFFFFF',
  },
};